<template>
    <div class="live_item test_teacher" 
        v-if="msg&&!~dataView.indexOf(msg.kind)"
        :key="msg.id"
        >
        <!-- 机器人诊股 -->
        <!-- <template v-if="msg&&!!~['robot'].indexOf(msg.kind) || msg.id === '830100'">
      <div class="robot_box">
        <div class="robot_title">
          <span class="user_name">@机器人诊股</span>
          <span>AGP_8A9AD2D刚刚诊断了均胜电子，该股份上涨动力得分为**，预计未来3-5个交易日…</span>
        </div>
        <div class="robot_content_box">
          <div class="robot_avatar">
            <img
              src="https://img1-cdn-picsh.aigupiao.com/user/avatar/2019-12-26/5abc2243bab12e27eb704f7abc4139d7.jpg"
              alt
            />
          </div>
          <div class="robot_content"></div>
          <div class="robot_read_num">1059人看过</div>
        </div>
      </div>
        </template>-->
        <!-- 高手问答 -->
        <!-- <template v-else-if="msg&&!!~['qa'].indexOf(msg.kind)">22</template> -->
        <!-- 广告 -->
        <!-- <template v-else-if="msg&&!!~['ad'].indexOf(msg.kind)">33</template> -->
        <!-- 混合轮播问答 -->
        <!-- <template v-else-if="msg&&!!~['mix'].indexOf(msg.kind)">44</template> -->
        <!-- k线训练营 -->
        <!-- <template v-else-if="msg&&!!~['k_line_training_camp'].indexOf(msg.kind)">55</template> -->
        <!-- 趣味竞猜 -->
        <!-- <template v-else-if="msg&&!!~['guess'].indexOf(msg.kind)">66</template> -->
        <!-- 高手和用户消息 包括free免费高手消息 charge高手专栏 vip高手付费消息 user_msg用户消息 -->
        <template v-if="msg&&!~dataView.indexOf(msg.kind)">
            <div
                class="is_only_self_show"
                v-if="msg.only_self_show === 'yes'"
                @click="handleClickToLiveDetail(msg.kind, msg.id)"
            >仅自己可见</div>

            <div
                class="is_only_self_show is_fans_show"
                v-if="msg.is_fans_show == 1"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <circle cx="6.41524" cy="4.02844" r="2.75" stroke="#939393"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.91791 12.7216C9.91791 12.7216 7.45866 11.1794 7.32564 9.97992C7.19261 8.78043 7.95131 8.22162 8.62177 8.22162C9.29223 8.22162 9.91791 8.68735 9.91791 8.68735C9.91791 8.68735 10.5977 8.22162 11.2744 8.22162C11.9511 8.22162 12.561 9.03925 12.4564 9.97992C12.3519 10.9206 9.91791 12.7216 9.91791 12.7216Z" stroke="#939393"/>
                    <path d="M6.41524 6.77844C6.41524 6.77844 1.75855 6.56079 1.53181 11.6956C1.53181 11.8244 1.61436 11.8841 1.65187 11.9392C1.76712 12.1086 2.23501 12.1739 2.23501 12.1739H6.41524" stroke="#939393" stroke-linecap="round"/>
                </svg>
            仅粉丝可见</div>

            <!-- 仅会员可见 -->
            <div
                class="is_only_self_show is_vip_show"
                v-if="msg.not_vip_show == 'no' && msg.vip_show == 'yes' && msg.unshow_group.length == 0"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <circle cx="6.41524" cy="4.02844" r="2.75" stroke="#939393"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.91791 12.7216C9.91791 12.7216 7.45866 11.1794 7.32564 9.97992C7.19261 8.78043 7.95131 8.22162 8.62177 8.22162C9.29223 8.22162 9.91791 8.68735 9.91791 8.68735C9.91791 8.68735 10.5977 8.22162 11.2744 8.22162C11.9511 8.22162 12.561 9.03925 12.4564 9.97992C12.3519 10.9206 9.91791 12.7216 9.91791 12.7216Z" stroke="#939393"/>
                    <path d="M6.41524 6.77844C6.41524 6.77844 1.75855 6.56079 1.53181 11.6956C1.53181 11.8244 1.61436 11.8841 1.65187 11.9392C1.76712 12.1086 2.23501 12.1739 2.23501 12.1739H6.41524" stroke="#939393" stroke-linecap="round"/>
                </svg>
            仅会员可见</div>

            <div class="live_header" @click="handleClickToLiveDetail(msg.kind, msg.id)">
                <div class="is_top_msg" v-if="msg.state2 === 'top'"></div>
                <dl class="user_detail" v-if="live&&live.image">
                    <dt @click.stop="handleClickToDetail(msg.kind, live.id)">
                        <img :src="live.image" alt="用户头像" />
                    </dt>
                    <dd>
                        <h4 @click.stop>
                            <span
                                @click="handleClickToDetail(msg.kind, live.id)"
                                class="user_name"
                            >{{live.title}}</span>
                            <template v-if="live && live.user_medals_tail && live.user_medals_tail.length > 0">
                                <span
                                    class="user_symbol"
                                    v-for="(item, index) in live.user_medals_tail"
                                    :key="index"
                                >
                                    <img :src="item.image" alt="" />
                                </span>
                            </template>
                            <template v-else-if="false">
                                <span class="user_symbol" v-if="live.serve_vip === 'yes'">
                                    <img
                                        src="https://cdncos.aigupiao.com/assets/pc/img/tougu_2019.png"
                                        alt="投顾"
                                    />
                                </span>
                                <span class="user_symbol" v-else-if="live.platform && live.platform == '9'">
                                    <img
                                        src="https://cdncos.aigupiao.com/assets/pc/img/blue_v.png"
                                        alt="蓝v"
                                    />
                                </span>
                                <span class="user_symbol" v-else-if="live.platform && live.platform == '8'">
                                    <img
                                        src=" https://cdncos.aigupiao.com/assets/pc/img/v_column.png"
                                        alt="专栏"
                                    />
                                </span>
                                <span
                                    class="user_symbol"
                                    v-else-if="live.platform && live.platform != '8' && live.platform != '9'"
                                >
                                    <img
                                        src="https://img1-cdn-picsh.aigupiao.com/m/image_lib/2023-09-06/5bce8ec43c43ed2b302634ffbe4a9382=39X39.png"
                                        alt="黄V"
                                    />
                                </span>
                                <span
                                    class="user_symbol"
                                    v-else-if="live.is_talent && live.is_talent === 'yes'"
                                >
                                    <img
                                        src="https://img1-cdn-picsh.aigupiao.com/m/image_lib/2023-09-06/77ac74c814fb1862323045c6d8d0f35f=39X39.png"
                                        alt="达人"
                                    />
                                </span>
                            </template>
                        </h4>
                        <p
                            v-if="msg.rec_time_desc"
                        >发表于 {{msg.rec_time_desc}}&nbsp;&nbsp;&nbsp;{{msg.view_num}}</p>
                    </dd>
                </dl>
                <!-- <div class="user_operation">
          <img :src="require('@/assets/images/icon-there-dot@2x.png')" />
                </div>-->
            </div>
            <div class="live_content_box">
                <div v-if="msg.kind === 'vip'">
                    <div v-if="msg.is_show === 'no' || !msg.content">
                        <div class="members_only">
                            <div
                                @click="handleClickToLiveDetail(msg.kind, msg.id)"
                                class="members_only_free"
                                v-html="msg.brief"
                            ></div>
                            <div class="members_only_box">
                                <div class="vip_nosee_company" @click="openDownloadAppPop">
                                    <span></span>
                                    <div class="vip_company_info open_member">
                                        <b>会员专享信息，请开通VIP服务查看</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="msg.is_show === 'yes' && msg.content "
                        @click="handleClickToLiveDetail(msg.kind, msg.id)"
                    >
                        <div class="member_brief" v-html="msg.brief"></div>
                        <div class="member_pad"></div>
                        <div class="member_news_box">
                            <div class="member_news">
                                <div class="member_news_header">
                                    <dl>
                                        <dt>
                                            <img
                                                alt
                                                :src="require('@/assets/images/icon-vip-yellow@2x.png')"
                                            />
                                        </dt>
                                        <dd>
                                            <h4>
                                                以下内容会员独享
                                                <span
                                                    v-if="msg.vip_group_info "
                                                >({{msg.vip_group_info}})</span>
                                            </h4>
                                            <!-- <p>本收费产品由{{msg.company}}提供</p> -->
                                        </dd>
                                    </dl>
                                </div>

                                <div class="member_news_content member_news_content_25" 
                                        :class="['member_news_content_25_'+msg.id , !showMoreClass ? 'normalShow' : '', {
                                            bindShow: showMoreFlag && showMoreClass
                                        }]"
                                      >
                                
                                    <span :class="['member_news_content_'+msg.id]" v-html="msg.content"></span>

                                    <button class="show_more_wrap" :class="{isAd: isAd}" v-if="showMoreFlag && showMoreClass" @click.stop.prevent="checkFlagFn">全文</button>

                                    <span class="contentCloseBtn" v-if="showMoreFlag && !showMoreClass" @click.stop.prevent="checkFlagFn">收起</span>
                                </div>


                                <div
                                    v-if="(msg.img_hd && msg.img_hd.length > 0) || (msg.menus && msg.menus.length > 0)"
                                    @click.stop
                                >
                                    <image-viewpoint :msg="msg"></image-viewpoint>
                                </div>
                                <div class="member_content_pad"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 是否是高手免费消息 -->
                <div
                    v-if="msg.kind === 'free' ||  (msg.kind === 'user_msg' &&  msg.content_type === '0' )"
                >
                    <!-- 非仅粉丝可见 或者 仅粉丝可见+可见 -->
                    <div v-if="msg.is_fans_show == 0 || is_fans_show_ok === true">
                        <!-- 文字部分  展开收起开关：live_content082901  -->
                        <div class="live_content live_content082901">
                            <div @click="handleClickToLiveDetail(msg.kind, msg.id)" :class="{ normalShow: !showMoreClass, bindShow: showMoreFlag && showMoreClass }">
                                <span :class="'contentWrapSpan'+msg.id" v-html="msg.content"></span>
                                <span class="contentCloseBtn" v-if="showMoreFlag && !showMoreClass" @click.stop.prevent="checkFlagFn">收起</span>
                            </div>
                            <button class="show_more_wrap" :class="{isAd: isAd}" v-if="showMoreFlag && showMoreClass" @click.stop.prevent="checkFlagFn">全文</button>

                        </div>

                        <!-- 音频消息 -->
                        <div v-if="msg.audio && msg.audio !== ''">
                            <audio-msg-wrap :audioLen="msg.audio_len"></audio-msg-wrap>
                        </div>
                        <!-- 图片部分有图片或者视屏则都显示缩略图 -->
                        <div
                            v-if="msg.image && msg.image.length > 0  || (msg.menus && msg.menus.length > 0) "
                        >
                            <image-viewpoint :msg="msg"></image-viewpoint>
                        </div>

                        <!-- 分享板块 -->
                        <div
                            v-if="msg.share_msg && msg.share_msg.length && msg.share_msg[0].share_msg_kind ==='theme' "
                        >
                            <div class="transpond_plate_wrap" @click="openDownloadAppPop">
                                <div class="transpond_plate_content">
                                    <div class="transpond_title">
                                        <p
                                            v-if="msg.share_msg[0]"
                                            :class="['plate_stock_info', isGoUp( msg.share_msg[0].chg_pct ) ? 'to_red' : 'to_green']"
                                        >
                                            <span
                                                class="to_red"
                                                v-if="isGoUp(msg.share_msg[0].chg_pct)"
                                            >+{{twoDecimalPlaces(msg.share_msg[0].chg_pct+'') }}%</span>
                                            <span
                                                class="to_green"
                                                v-else
                                            >{{twoDecimalPlaces(msg.share_msg[0].chg_pct+'') }}%</span>
                                        </p>
                                    </div>

                                    <div class="transpond_detail">
                                        <div class="transpond_list">
                                            <p class="plate">
                                                <span>{{msg.share_msg[0].title}}</span>
                                                <span
                                                    class="plate-code"
                                                >&nbsp;({{msg.share_msg[0].symbol}})</span>
                                            </p>
                                            <div class="plate_info_right">
                                                <p>
                                                    <span>近期讨论: {{msg.share_msg[0].theme_num}}条</span>
                                                    <img
                                                        :src="require('@/assets/images/icon-unfold.png') "
                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 分享股票 -->
                        <div v-if="msg.share_kind && msg.share_kind === 'stock'  && msg.share_msg">
                            <div class="transpond_stock_wrap">
                                <div
                                    class="transpond_stock_content"
                                    v-for="(item,index) in msg.share_msg"
                                    :key="index"
                                    @click="handleClickToStockPage(item.stock_code)"
                                >
                                    <div class="transpond_title">
                                        <p
                                            v-if="item.stock_market"
                                            :class="['stock_stock_info', isGoUp( item.stock_market.chg_pct ) ? 'to_red' : 'to_green']"
                                        >
                                            <span>{{twoDecimalPlaces(item.stock_market.price+'')}}</span>
                                            <span>{{isGoUp( item.stock_market.chg_pct ) ? '' : ''}}{{ item.stock_market.chg_pct }}%</span>
                                        </p>
                                    </div>
                                    <div class="transpond_detail">
                                        <div class="transpond_list">
                                            <p class="stock">
                                                <span>{{item.stock_name}}</span>
                                                <span class="stock-code">&nbsp;({{item.stock_code}})</span>
                                            </p>
                                            <div class="stock_info_right">
                                                <p>
                                                    <span>{{item.comment_num}}</span>
                                                    <img
                                                        :src="require('@/assets/images/icon-unfold.png') "
                                                    />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 分享竞猜todo -->
                        <div
                            v-if="msg.guess&&msg.guess.length"
                            class="transpond_guess"
                            @click="hanleClickToPage(`/StockGuess/market/id/${msg.guess[0].id}`)"
                        >
                            <div class="transpond_guess_content">
                                <div class="transpond_title">
                                    <img alt :src="require('@/assets/images/icon_guessing.png')" />
                                    <div class="plate_img_text">趣味竞猜</div>
                                </div>
                                <div class="transpond_detail">
                                    <div class="guess_list">
                                        <h5 class="guess_title">{{msg.guess[0].title}}</h5>
                                        <p class="guess_num">参与人数：{{msg.guess[0].total_num}}</p>
                                    </div>
                                    <div class="guess_btns">
                                        <div class="guess_btn">查看</div>
                                        <div class="guess_btn">跟单</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 分享投票 -->
                        <div v-if="msg.vote_info && msg.vote_info.length">
                            <div class="transpond_vote_wrap" @click="$downapppop.open">
                                <div class="transpond_vote_content">
                                    <div
                                        class="transpond_vote_title"
                                    >{{msg.vote_info[0].vote_title}}</div>
                                    <div
                                        class="transpond_vote_desc"
                                        v-if="msg.vote_info[0].vote_desc"
                                    >{{msg.vote_info[0].vote_desc}}</div>
                                    <ul class="transpond_vote_items">
                                        <li
                                            v-for="(item,index) in msg.vote_info[0].option"
                                            :key="index"
                                        >{{item.option_title}}</li>
                                    </ul>
                                    <div class="transpond_vote_footer">
                                        <div class="close_time">{{msg.vote_info[0].custom_ended_at}}</div>
                                        <div class="create_user">
                                            <span class="create_user_name">@{{live.title}}</span>&nbsp;创建
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 分享期货 -->
                        <!-- <div v-if="msg.share_kind && !!~['futures'].indexOf(msg.share_kind)">
              <div class="nonsupport_box">
                <a
                  href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui"
                >[暂不支持分享期货,请下载APP查看]</a>
              </div>
                        </div>-->
                        <!-- 分享k线训练营-->
                        <div v-if="msg.share_kind && !!~['kline_game'].indexOf(msg.share_kind)">
                            <div class="transpond_kline_wrap" @click="$downapppop.open">
                                <div class="transpond_kline_content">
                                    <div class="kline_img">
                                        <img :src="require('@/assets/images/icon_k_line.gif')" />
                                    </div>
                                    <div class="kline_detail">
                                        <h3>{{msg.share_msg[0].title}}</h3>
                                        <div class="user_box">
                                            <ul class="user_list">
                                                <li
                                                    v-for="(item,index) in msg.share_msg[0].join_user"
                                                    :key="'kline_'+index"
                                                >
                                                    <img :src="item.image" />
                                                </li>
                                            </ul>
                                            <p class="user_num">{{msg.share_msg[0].join_num}}</p>
                                        </div>
                                    </div>
                                    <div class="kline_challenge">我要挑战</div>
                                </div>
                            </div>
                        </div>
                        <!-- 分享语音直播间 -->
                        <div
                            v-if="msg.share_kind && !!~['share_audio_live'].indexOf(msg.share_kind)"
                        >
                            <div class="transpond_audio_live_wrap" @click="$downapppop.open">
                                <div class="transpond_audio_live_content">
                                    <div class="transpond_audio_live_info">
                                        <div class="bg">
                                            <img :src="msg.share_msg[0].avatar" />
                                            <div class="shade_wrap"></div>
                                        </div>
                                        <div
                                            v-if="msg.share_msg[0].status === 'started'"
                                            class="live_attendance"
                                            :style="{backgroundImage: 'url('+ require('@/assets/images/icon_live_attendance@2x.png') +')'}"
                                        >
                                            <div class="icon_audio_started"></div>
                                            <p>{{msg.share_msg[0].hot}}</p>
                                        </div>
                                        <div
                                            v-if="msg.share_msg[0].status === 'pending'"
                                            class="about_of_live_attendance"
                                        >
                                            <p>即将开播</p>
                                        </div>
                                        <div
                                            v-if="msg.share_msg[0].status === 'ended'"
                                            class="over_attendance"
                                        >
                                            <div
                                                class="play_icon"
                                                :style="{backgroundImage: 'url('+ require('@/assets/images/icon_over_attendance@2x.png') +')'}"
                                            ></div>
                                            <div
                                                class="over_attendance_num"
                                            >{{msg.share_msg[0].hot}}</div>
                                        </div>
                                    </div>
                                    <div class="transpond_detail">
                                        <h3>{{msg.share_msg[0].title}}</h3>
                                        <p>{{msg.share_msg[0].nickname}}·{{msg.share_msg[0].desc}}</p>
                                    </div>
                                    <div class="join_wrap">
                                        <div
                                            class="live_streaming"
                                            :class="'live'"
                                            v-if="msg.share_msg[0].status === 'started'"
                                        >直播中</div>
                                        <div
                                            class="live_streaming"
                                            :class="'over'"
                                            v-else-if="msg.share_msg[0].status === 'ended'"
                                        >已结束</div>
                                        <div
                                            class="live_streaming"
                                            :class="'about_of'"
                                            v-else-if="msg.share_msg[0].status === 'pending'"
                                        >即将开播</div>

                                        <div class="audio_live_price">
                                            {{msg.share_msg[0].tips}}
                                            <span
                                                class="join_icon"
                                                :style="{backgroundImage: 'url('+ require('@/assets/images/icon_join_info@2x.png') +')'}"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 属于转发的模块 -->
                        <div v-if="msg.forward_info&& msg.forward_info.length">
                            <div v-if="msg.forward_info[0].forward_info_kind === 'stock_group'">
                                <!-- 转发组合todo -->
                                <div
                                    class="transpond_simulation_wrap"
                                    @click="$downapppop.open"
                                    v-for="(item,index) in msg.forward_info"
                                    :key="'simulation'+index"
                                >
                                    <div class="transpond_simulation_content">
                                        <div class="transpond_title">
                                            <p
                                                v-if="true"
                                                :class="['simulation_stock_info',  isGoUp( item.profit_rate )  ? 'to_red' : 'to_green']"
                                            >
                                                <span>{{item.profit_rate}}%</span>
                                                <span>总收益</span>
                                            </p>
                                        </div>
                                        <div class="transpond_detail">
                                            <div class="transpond_list">
                                                <p class="simulation">
                                                    <span>{{item.group_name}}</span>
                                                </p>
                                                <div class="simulation_info_right">
                                                    <p>
                                                        <span>近期讨论：{{item.comment_num}}条</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="attention_box">
                                            <div
                                                class="attention_btn"
                                                v-if="item.is_follow === 'no'"
                                            >关注</div>
                                            <div
                                                class="p"
                                                v-else-if="item.is_follow === 'yes'"
                                            >已关注</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="msg.forward_info[0].forward_info_kind === 'express'">
                                <!-- 转发要闻todo -->
                                <div
                                    class="transpond_important_news"
                                    v-for="(item,index) in msg.forward_info"
                                    :key="'express'+index"
                                >
                                    <div class="news_bg" @click="handleClickNewsDetail(item.id)">
                                        <p>
                                            <span class="important_news_mark">[要闻]&nbsp;</span>
                                            <span>{{item.last_content}}</span>
                                            <span
                                                v-if="!slefNoHasImgVideo && item.menus.length"
                                                class="icon_video"
                                            >
                                                <img
                                                    :src="require('@/assets/images/icon_forward_video@2x.png')"
                                                    alt
                                                />
                                            </span>
                                            <span
                                                v-else-if="!slefNoHasImgVideo && item.image.length"
                                                class="icon_img"
                                            >
                                                <img
                                                    :src="require('@/assets/images/icon_forward_img@2x.png')"
                                                    alt
                                                />
                                            </span>
                                        </p>
                                    </div>
                                    <div
                                        class="transpond_ordinary_image"
                                        v-if="slefNoHasImgVideo && ((item.image && item.image.length) || (item.menus && item.menus.length)) "
                                    >
                                        <image-viewpoint :msg="item"></image-viewpoint>
                                    </div>
                                </div>
                            </div>
                            <!-- 转发平台专栏 -->
                            <div v-if="msg.forward_info[0].forward_info_kind === 'news'">
                                <div
                                    class="transpond_special_column"
                                    v-for="(item,index) in msg.forward_info"
                                    :key="'news'+index"
                                >
                                    <div class="transpond_box">
                                        <div
                                            class="transpond_content"
                                            @click="handleClickAGPNewsDetail(item.id)"
                                        >
                                            <h4 class="transpond_title">{{item.title}}</h4>
                                            <p class="transpond_brief">
                                                <span v-html="item.brief || item.last_content "></span>
                                                <span
                                                    v-if="!slefNoHasImgVideo && item.image"
                                                    class="icon_img"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_forward_img@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                            </p>
                                        </div>
                                        <div
                                            class="transpond_ordinary_image"
                                            v-if="slefNoHasImgVideo && item.image"
                                        >
                                            <image-viewpoint :msg="{image:[item.image],menus:[]}"></image-viewpoint>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 转发专栏 -->
                            <div
                                v-if="((msg.forward_info[0].forward_info_kind === 'live_msg' || msg.forward_info[0].forward_info_kind === 'user_msg')
                            &&msg.forward_info[0].msg.kind==='charge')"
                            >
                                <div
                                    class="transpond_special_column"
                                    v-for="(item,index) in msg.forward_info"
                                    :key="'column'+index"
                                >
                                    <div class="transpond_box">
                                        <div
                                            class="transpond_content"
                                            @click="handleClickToTranspondLiveDetail(item.msg.kind, item.msg.id)"
                                        >
                                            <div class="user_msg">
                                                <span
                                                    class="user_name"
                                                    @click="handleClickToDetail(item.msg.kind, item.live.id)"
                                                >
                                                    {{item.live.title}}
                                                    {{ !item.live.title || item.live.title === '' ? '' : ':'}}
                                                </span>
                                            </div>
                                            <h4 class="transpond_title">{{item.msg.title}}</h4>
                                            <p class="transpond_brief">
                                                <span
                                                    v-html="item.msg.brief || item.msg.last_content "
                                                ></span>

                                                <span
                                                    v-if="!slefNoHasImgVideo && item.msg.menus && item.msg.menus.length"
                                                    class="icon_video"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_forward_video@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                                <span
                                                    v-else-if="!slefNoHasImgVideo && item.msg.image.length"
                                                    class="icon_img"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_forward_img@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                            </p>
                                        </div>
                                        <div
                                            class="transpond_ordinary_image"
                                            v-if="slefNoHasImgVideo && (item.msg.image && item.msg.image.length)"
                                        >
                                            <image-viewpoint :msg="item.msg"></image-viewpoint>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 转发消息 -->
                            <div
                                class="transpond_vip_box"
                                v-if="!!~['live_msg','user_msg'].indexOf(msg.forward_info[0].forward_info_kind)"
                            >
                                <!-- 转发vip可见消息 -->
                                <div
                                    class="transpond_vip"
                                    v-if="~['vip'].indexOf(msg.forward_info[0].msg.kind) && msg.forward_info[0].msg.is_show === 'yes'"
                                >
                                    <div
                                        class="member_brief transpond"
                                        @click="handleClickToLiveDetail(msg.forward_info[0].msg.kind, msg.forward_info[0].msg.id)"
                                    >
                                        <span class="user_name">{{msg.forward_info[0].live.title}}:</span>
                                        {{msg.forward_info[0].msg.brief}}
                                    </div>
                                    <div class="member_pad"></div>
                                    <div class="member_news_box">
                                        <div
                                            class="member_news"
                                            @click="handleClickToLiveDetail(msg.forward_info[0].msg.kind, msg.forward_info[0].msg.id)"
                                        >
                                            <div class="member_news_header">
                                                <dl>
                                                    <dt>
                                                        <img
                                                            alt
                                                            :src="require('@/assets/images/icon-vip-yellow@2x.png')"
                                                        />
                                                    </dt>
                                                    <dd>
                                                        <h4>以下内容会员独享 {{msg.forward_info[0].msg.vip_group_info ? '(' + msg.forward_info[0].msg.vip_group_info + ')' : null}}</h4>
                                                    </dd>
                                                </dl>
                                            </div>
                                            <div class="member_news_content">
                                                <span
                                                    v-html=" msg.forward_info[0].msg.content || msg.forward_info[0].msg.last_content || msg.forward_info[0].msg.brief "
                                                ></span>
                                                <span
                                                    v-if="!slefNoHasImgVideo && msg.forward_info[0].msg.menus.length"
                                                    class="icon_video"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_forward_video@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                                <span
                                                    v-else-if="!slefNoHasImgVideo && msg.forward_info[0].msg.image.length"
                                                    class="icon_img"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_forward_img@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                            </div>
                                            <div
                                                class="transpond_ordinary_image"
                                                v-if="slefNoHasImgVideo && (msg.forward_info[0].msg.image.length  || msg.forward_info[0].msg.menus.length)"
                                                @click.stop
                                            >
                                                <image-viewpoint :msg="msg.forward_info[0].msg"></image-viewpoint>
                                            </div>
                                            <div class="member_content_pad"></div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 转发vip不可见消息 -->
                                <div
                                    class="transpond_vip"
                                    v-if="~['vip'].indexOf(msg.forward_info[0].msg.kind) && msg.forward_info[0].msg.is_show === 'no'"
                                >
                                    <div
                                        class="members_only"
                                        v-for="(item,i) in msg.forward_info"
                                        :key="i"
                                    >
                                        <div
                                            class="members_only_free transpond"
                                            @click="handleClickToLiveDetail(item.msg.kind, item.msg.id)"
                                        >
                                            <span class="user_name">{{ item.live.title }}:</span>
                                            <span v-html="item.msg.brief"></span>
                                        </div>
                                        <div class="members_only_box zf border-1px">
                                            <div
                                                class="vip_nosee_company"
                                                @click="openDownloadAppPop"
                                            >
                                                <span></span>
                                                <div class="vip_company_info open_member">
                                                    <b>会员专享信息，请开通VIP服务查看</b>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 转发普通消息 -->
                                <div
                                    v-if="!~['charge','vip'].indexOf(msg.forward_info[0].msg.kind)"
                                >
                                    <div
                                        class="transpond_ordinary"
                                        v-for="(item,i) in msg.forward_info"
                                        :key="i"
                                    >
                                        <div
                                            class="transpond_ordinary_content"
                                            v-if="msg.forward_info[0].forward_info_kind === 'live_msg'"
                                        >
                                            <p
                                                @click="handleClickToLiveDetail(item.msg.kind, item.msg.id)"
                                                class="transpond_ordinary_content_text"
                                            >
                                                <span
                                                    class="user_name"
                                                    @click="handleClickToDetail( item.msg.kind, item.live.id)"
                                                >{{item.live.title}}：</span>
                                                <span
                                                    v-html="(item.msg.content) || (item.msg.last_content)"
                                                ></span>
                                                <span
                                                    v-if="item.msg.vote_info && item.msg.vote_info.length"
                                                    class="icon_vote"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_vote@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                                <span
                                                    v-if="!slefNoHasImgVideo && item.msg.menus && item.msg.menus.length"
                                                    class="icon_video"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_forward_video@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                                <span
                                                    v-else-if="!slefNoHasImgVideo && item.msg.image.length"
                                                    class="icon_img"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_forward_img@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                            </p>
                                        </div>
                                        <div
                                            class="transpond_ordinary_content"
                                            v-else-if="msg.forward_info[0].forward_info_kind === 'user_msg'"
                                        >
                                            <p
                                                @click="handleClickToLiveDetail(item.msg.kind, item.msg.id)"
                                                class="transpond_ordinary_content_text"
                                            >
                                                <span
                                                    class="user_name"
                                                    @click="handleClickToDetail( item.msg.kind, item.user.id)"
                                                >{{item.user.title}}：</span>
                                                <span
                                                    v-html="(item.msg.content) || (item.msg.last_content)"
                                                ></span>
                                                <span
                                                    v-if="item.msg.vote_info && item.msg.vote_info.length"
                                                    class="icon_vote"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_vote@2x.png')"
                                                        alt
                                                    />
                                                </span>

                                                <span
                                                    v-if="!slefNoHasImgVideo && item.msg.menus && item.msg.menus.length"
                                                    class="icon_video"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_forward_video@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                                <span
                                                    v-else-if="!slefNoHasImgVideo && item.msg.image.length"
                                                    class="icon_img"
                                                >
                                                    <img
                                                        :src="require('@/assets/images/icon_forward_img@2x.png')"
                                                        alt
                                                    />
                                                </span>
                                            </p>
                                        </div>

                                        <!-- 转发语音消息 -->
                                        <div
                                            v-if="item.msg.audio && item.msg.audio !== ''"
                                            class="transpond_audio_wrap"
                                        >
                                            <audio-msg-wrap
                                                :audioLen="parseInt(item.msg.audio_len)"
                                            ></audio-msg-wrap>
                                        </div>

                                        <!-- 满足消息本身没有图片并且转发的消息有图片时显示转发的图片-->
                                        <div
                                            class="transpond_ordinary_image"
                                            v-if="slefNoHasImgVideo && (item.msg.image && item.msg.image.length  || item.msg.menus && item.msg.menus.length)"
                                        >
                                            <image-viewpoint :msg="item.msg"></image-viewpoint>
                                        </div>
                                        <div class="forward-main">
                                            <!-- 转发消息中的板块 -->
                                            <div
                                                v-if="item.msg.share_msg && item.msg.share_msg.length && item.msg.share_msg[0].share_msg_kind ==='theme'"
                                            >
                                                <div
                                                    class="transpond_plate_wrap"
                                                    v-for="(themeItem,index) in item.msg.share_msg"
                                                    :key="'theme'+index"
                                                    @click="openDownloadAppPop"
                                                >
                                                    <div class="transpond_plate_content">
                                                        <div class="transpond_title">
                                                            <p
                                                                v-if="themeItem"
                                                                :class="['plate_stock_info',isGoUp(themeItem.chg_pct) ? 'to_red' : 'to_green']"
                                                            >
                                                                <span
                                                                    class="to_red"
                                                                    v-if="isGoUp(themeItem.chg_pct)"
                                                                >+{{twoDecimalPlaces(themeItem.chg_pct.toString()) }}%</span>
                                                                <span
                                                                    class="to_green"
                                                                    v-else
                                                                >{{twoDecimalPlaces(themeItem.chg_pct.toString()) }}%</span>
                                                            </p>
                                                        </div>

                                                        <div class="transpond_detail">
                                                            <div class="transpond_list">
                                                                <p class="plate">
                                                                    <span>{{themeItem.title}}</span>
                                                                    <span
                                                                        class="plate-code"
                                                                    >&nbsp;({{themeItem.symbol}})</span>
                                                                </p>
                                                                <div class="plate_info_right">
                                                                    <p>
                                                                        <span>近期讨论：{{themeItem.theme_num}}条</span>
                                                                        <img
                                                                            :src="require('@/assets/images/icon-unfold.png') "
                                                                        />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 转发消息中的分享竞猜 -->

                                            <div
                                                v-if="item.msg.guess&&item.msg.guess.length"
                                                class="transpond_guess"
                                                @click="hanleClickToPage(`/StockGuess/market/id/${item.msg.guess[0].id}`)"
                                            >
                                                <div class="transpond_guess_content">
                                                    <div class="transpond_title">
                                                        <img
                                                            alt
                                                            :src="require('@/assets/images/icon_guessing.png')"
                                                        />
                                                        <div class="plate_img_text">趣味竞猜</div>
                                                    </div>
                                                    <div class="transpond_detail">
                                                        <div class="guess_list">
                                                            <h5
                                                                class="guess_title"
                                                            >{{item.msg.guess[0].title}}</h5>
                                                            <p
                                                                class="guess_num"
                                                            >参与人数：{{item.msg.guess[0].total_num}}</p>
                                                        </div>
                                                        <div class="guess_btns">
                                                            <div class="guess_btn">查看</div>
                                                            <div class="guess_btn">跟单</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 转发消息中的股票 -->

                                            <div
                                                v-if=" item.msg.share_msg && item.msg.share_kind && item.msg.share_kind === 'stock'  "
                                            >
                                                <div class="transpond_stock_wrap">
                                                    <div
                                                        class="transpond_stock_content"
                                                        v-for="(stockItem,index) in item.msg.share_msg"
                                                        :key="'stock'+index"
                                                    >
                                                        <div
                                                            class="transpond_title"
                                                            @click="handleClickToStockPage(stockItem.stock_code)"
                                                        >
                                                            <p
                                                                v-if="stockItem.stock_market"
                                                                :class="['stock_stock_info', isGoUp( stockItem.stock_market.chg_pct ) ? 'to_red' : 'to_green']"
                                                            >
                                                                <span>{{twoDecimalPlaces(stockItem.stock_market.price+'')}}</span>
                                                                <span>{{isGoUp( stockItem.stock_market.chg_pct ) ? '' : ''}}{{ stockItem.stock_market.chg_pct }}%</span>
                                                            </p>
                                                        </div>
                                                        <div class="transpond_detail">
                                                            <div
                                                                class="transpond_list"
                                                                @click="handleClickToStockPage(stockItem.stock_code)"
                                                            >
                                                                <p class="stock">
                                                                    <span>{{stockItem.stock_name}}</span>
                                                                    <span
                                                                        class="stock-code"
                                                                    >&nbsp;({{stockItem.stock_code}})</span>
                                                                </p>
                                                                <div class="stock_info_right">
                                                                    <p>
                                                                        <span>{{stockItem.comment_num}}</span>
                                                                        <img
                                                                            :src="require('@/assets/images/icon-unfold.png') "
                                                                        />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 转发消息中k线训练营-->
                                            <div
                                                v-if="item.msg.share_msg && item.msg.share_kind && item.msg.share_kind === 'kline_game'"
                                            >
                                                <div
                                                    class="transpond_kline_wrap"
                                                    v-for="(klineItem,index) in item.msg.share_msg"
                                                    :key="'kline'+index"
                                                    @click="$downapppop.open"
                                                >
                                                    <div class="transpond_kline_content">
                                                        <div class="kline_img">
                                                            <img
                                                                :src="require('@/assets/images/icon_k_line.gif')"
                                                            />
                                                        </div>
                                                        <div class="kline_detail">
                                                            <h3>参与K线挑战赢取金币</h3>
                                                            <div class="user_box">
                                                                <ul class="user_list">
                                                                    <li
                                                                        v-for="(item,index) in klineItem.join_user"
                                                                        :key="index"
                                                                    >
                                                                        <img :src="item.image" />
                                                                    </li>
                                                                </ul>
                                                                <p
                                                                    class="user_num"
                                                                >{{klineItem.join_num}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="kline_challenge">我要挑战</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 分享语音直播间 -->
                                            <div
                                                v-if="item.msg.share_msg && item.msg.share_kind && item.msg.share_kind === 'share_audio_live'"
                                            >
                                                <div
                                                    class="transpond_audio_live_wrap"
                                                    v-for="(audioItem,index) in item.msg.share_msg"
                                                    :key="'stock'+index"
                                                    @click="$downapppop.open"
                                                >
                                                    <div class="transpond_audio_live_content">
                                                        <div class="transpond_audio_live_info">
                                                            <div class="bg">
                                                                <img :src="audioItem.avatar" />
                                                                <div class="shade_wrap"></div>
                                                            </div>
                                                            <div
                                                                v-if="audioItem.status === 'started'"
                                                                class="live_attendance"
                                                                :style="{backgroundImage: 'url('+ require('@/assets/images/icon_live_attendance@2x.png') +')'}"
                                                            >
                                                                <div class="icon_audio_started"></div>
                                                                <p>{{audioItem.hot}}</p>
                                                            </div>
                                                            <div
                                                                v-if="audioItem.status === 'pending'"
                                                                class="about_of_live_attendance"
                                                            >
                                                                <p>即将开播</p>
                                                            </div>
                                                            <div
                                                                v-if="audioItem.status === 'ended'"
                                                                class="over_attendance"
                                                            >
                                                                <div
                                                                    class="play_icon"
                                                                    :style="{backgroundImage: 'url('+ require('@/assets/images/icon_over_attendance@2x.png') +')'}"
                                                                ></div>
                                                                <div
                                                                    class="over_attendance_num"
                                                                >{{audioItem.hot}}人气</div>
                                                            </div>
                                                        </div>
                                                        <div class="transpond_detail">
                                                            <h3>{{audioItem.title}}</h3>
                                                            <p>{{audioItem.nickname}}·{{audioItem.desc}}</p>
                                                        </div>
                                                        <div class="join_wrap">
                                                            <div
                                                                class="live_streaming"
                                                                :class="'live'"
                                                                v-if="audioItem.status === 'started'"
                                                            >直播中</div>

                                                            <div
                                                                class="live_streaming"
                                                                :class="'about_of'"
                                                                v-if="audioItem.status === 'pending'"
                                                            >即将开播</div>
                                                            <div
                                                                class="live_streaming"
                                                                :class="'over'"
                                                                v-if="audioItem.status === 'ended'"
                                                            >已结束</div>

                                                            <div class="audio_live_price">
                                                                {{audioItem.tips}}&nbsp;
                                                                <span
                                                                    class="join_icon"
                                                                    :style="{backgroundImage: 'url('+ require('@/assets/images/icon_join_info@2x.png') +')'}"
                                                                ></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 仅粉丝可见+不可见 -->
                    <div v-if="(is_fans_show_ok === false)">
                        <div class="live_content">
                            <div class="live_content_fans_noshow" @click="handleClickToLiveDetail" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                    <circle cx="10.2792" cy="5.81181" r="4.48838" stroke="#EC596C" stroke-width="1.1"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9967 20C15.9967 20 11.9829 17.4829 11.7657 15.5251C11.5486 13.5674 12.7869 12.6553 13.8812 12.6553C14.9755 12.6553 15.9967 13.4155 15.9967 13.4155C15.9967 13.4155 17.1063 12.6553 18.2107 12.6553C19.3152 12.6553 20.3106 13.9898 20.1399 15.5251C19.9692 17.0604 15.9967 20 15.9967 20Z" fill="#EC596C" fill-opacity="0.35" stroke="#EC596C" stroke-width="1.1"/>
                                    <path d="M10.2797 10.3C10.2797 10.3 2.67936 9.94479 2.3093 18.3255C2.3093 18.5357 2.44403 18.6332 2.50526 18.7232C2.69335 18.9996 3.45701 19.1062 3.45701 19.1062H10.2797" stroke="#EC596C" stroke-width="1.1" stroke-linecap="round"/>
                                </svg>
                                此内容仅粉丝可见，关注作者后即可查看
                            </div>
                            
                        </div>
                    </div>
                </div>
                <!-- 是否是高手专栏 -->
                <div v-if="msg.kind === 'charge'">
                    <div class="special_column" @click="handleClickToLiveDetail(msg.kind, msg.id)">
                        <h4 class="special_column_title">{{msg.title}}</h4>
                        <p class="special_column_content" v-html="msg.brief || msg.content "></p>
                    </div>
                    <div v-if="msg.img_hd && msg.img_hd.length > 0  && parseInt( msg.price) === 0">
                        <image-viewpoint :msg="msg"></image-viewpoint>
                    </div>
                    <div
                        v-if="parseInt( msg.price) > 0"
                        class="charge_kaitong_box"
                        @click="handleClickToLiveDetail(msg.kind, msg.id)"
                    >
                        <div class="charge_kaitong">
                            <span v-if="is_vip === 'no'">
                                本篇为付费专栏文章
                                <i class="price_text">￥{{parseInt( msg.price)}}.00</i>
                            </span>
                            <span v-else-if="msg.vip_price === '0'">付费专栏文章会员免费</span>
                            <span v-else>
                                付费专栏文章会员专享
                                <i class="price_text">￥{{msg.vip_price}}.00</i>
                            </span>
                        </div>
                    </div>
                </div>
                <div v-if="msg.kind === 'user_msg' && msg.content_type !== '0' ">
                    <div class="special_column" @click="handleClickToLiveDetail(msg.kind, msg.id)">
                        <h4 class="special_column_title">{{msg.title}}</h4>
                        <p class="special_column_content" v-html="msg.content"></p>
                    </div>
                    <div v-if="msg.img_hd && msg.img_hd.length > 0 ">
                        <image-viewpoint :msg="msg"></image-viewpoint>
                    </div>
                </div>
            </div>
            <div class="live_footer">
                <div class="footer_top_border">
                    <div class="give_like">
                        <span class="ub align-items justify-content" @click="handleClickToLike">
                            <img
                                v-if="isOccurLike"
                                class="isOccurLike"
                                :src="require('@/assets/images/icon_like_new_red@2x.png')"
                            />
                            <img
                                v-if="!isOccurLike"
                                :src="require('@/assets/images/icon_like_new.png')"
                                alt
                            />
                            <span
                                :class="['support_num', isOccurLike ? 'to_red' : '']"
                            >{{msg.support_num}}</span>
                        </span>
                    </div>
                    <div class="give_comment">
                        <span class="ub align-items justify-content" @click="$downapppop.open('分享')">
                            <img :src="require('@/assets/images/icon_msg_share.png')" alt />
                            <span>分享</span>
                        </span>
                    </div>
                    <div class="give_comment" @click="handleClickToComment">
                        <span class="ub align-items justify-content">
                            <img
                                v-if="+msg.comment_num > 0"
                                :src="require('@/assets/images/icon_comment_new_red@2x.png')"
                                alt
                            />
                            <img
                                v-if="+msg.comment_num <= 0"
                                :src="require('@/assets/images/icon_comment_new.png')"
                                alt
                            />
                            <span
                                :class="+msg.comment_num > 0 ?'to_red': ''"
                            >{{msg.comment_num == 0 ?'评论':msg.comment_num }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import imageViewpoint from "./imageViewpoint";
import AudioMsgWrap from "./AppAudioMsgWrap";
import HomePageApi from "@/api/homePage/";
import PublicApi from "@/api/publicApi/";
export default {
    name: "appLiveListPub",
    data() {
        return {
            isOccurLike: this.msg.is_support === "yes",
            randomStr: Math.random().toString(36).slice(-4),
            dataView: [
                "robot",
                "ad",
                "qa",
                "mix",
                "k_line_training_camp",
                "guess",
                "comment"
            ],
            user_id: parseInt(this.$route.params.id),
            vip_done:false,
            showMoreFlag: false,
            showMoreClass: true,
            isAd: "",
        };
    },
    props: {
        item: Object,
        live: Object,
        msg: Object,
        is_vip: String,
        indexItem: Number,
    },
    computed: {
        hasGetInfo() {
            return this.$store.state.user.hasGetInfo;
        },
        slefNoHasImgVideo() {
            return this.msg.image.length === 0 && this.msg.menus.length === 0;
        },
        is_fans_show_ok(){
            //用于设置了 仅粉丝可见
            if(this.msg.is_fans_show == 1){
                if(this.$store.state.user.is_follow == 'yes'){
                    //可见状态
                    return true;
                }
                else{
                    //不可见状态
                    return false;
                }
            }
            return 0;
        }
    },
    mounted() {
        if(this.msg.kind === 'vip'){
            //老师vip消息
            console.log('vip .msg.kind')
            let _dom_height = $('.member_news_content_'+this.msg.id).height();
            let _dom_h2 = $('.member_news_content_25_'+this.msg.id).height();
            console.log('vip dom',$('.member_news_content_'+this.msg.id),$('.member_news_content_25_'+this.msg.id))
            console.log('vip _dom_line_hei',_dom_height,_dom_h2)
            if(_dom_height && _dom_h2 && false){
                this.vip_done = true;
                if (_dom_height > _dom_h2) {
                    console.log('vip _dom_line_hei >')
                    this.showMoreFlag = true;
                } else {
                    this.showMoreFlag = false;
                }
            }
            if ($('.member_news_content').css('line-height') && _dom_height ) {
                let _dom_line_hei = $('.member_news_content').css('line-height').split('px')[0] * 1;
                //console.log('_dom_line_hei',_dom_line_hei* 4,_dom_height)
                if (_dom_height > _dom_line_hei * 4) {
                this.showMoreFlag = true;
                } else {
                this.showMoreFlag = false;
                }
            }

        }
        else{
            //老师普通消息 live_content082901
            let _dom_height = $('.contentWrapSpan'+this.msg.id).height();
            if ($('.live_content').css('line-height') && _dom_height ) {
                let _dom_line_hei = $('.live_content').css('line-height').split('px')[0] * 1;
                //console.log('_dom_line_hei',_dom_line_hei* 4,_dom_height)
                if (_dom_height > _dom_line_hei * 4) {
                this.showMoreFlag = true;
                } else {
                this.showMoreFlag = false;
                }
            }
        }


    var u = navigator.userAgent
    this.isAd = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器

    },
    components: {
        imageViewpoint,
        AudioMsgWrap,
    },
    created() {
        console.log(this.$store.state.user.is_follow,'is_follow')
        // console.log(this.slefNoHasImgVideo);
    },
    methods: {
        // 切换展示异常
        checkFlagFn() {
        this.showMoreClass = !this.showMoreClass
        },
        handleClickToLike() {
            //点赞功能
            let { id, kind, support_num } = this.msg;
            // const getLoginData = this.props.loginStore.loginData || {};
            // if (!getLoginData.token) {``
            // this.props.history.push('/default/login');
            // todo login
            // return null;
            // }
            if (!this.isOccurLike) {
                this.isOccurLike = true;
                this.msg.support_num = parseInt(support_num) + 1;
                let type = "live_msg";
                this.addPraise(id, type);
            }
        },
        addPraise(id, type) {
            PublicApi.addPraise(id, type);
        },
        // 直播详情
        handleClickToLiveDetail(kind, id) {
            //仅粉丝可见
            if(this.is_fans_show_ok === false){
                this.$downapppop.open('查看');
                return false;
            }

            if(kind == 'vip'){
                console.log('vip');
                let parent = this.$parent.$parent;
                if(parent.chatInfo && parent.chatInfo.chat_room_status == 1){
                    this.$parent.$parent.goToDetail(id);
                }
                return false;
            }

            // let { id, kind } = this.msg;
            let uri =
                location.origin === "http://192.168.31.170:8080"
                    ? "https://mobilebeta.aigupiao.com"
                    : "";
            if (kind === "user_msg") {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/usermsg/id/${ id }/jump_type/1.html`
                window.location.href = `${uri}/lives/usermsg/id/${id}/jump_type/1.html`;
                //如果是老师的动态跳转到老师动态详情
            } else {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/detail/id/${ id }/jump_type/1.html`
                window.location.href = `${uri}/Lives/detail/id/${id}/jump_type/1.html`;
            }
        },
        // 要闻跳转详情
        handleClickNewsDetail(id) {
            let uri =
                location.origin === "http://192.168.31.170:8080"
                    ? "https://mobilebeta.aigupiao.com"
                    : "";
            // this.props.history.push(`/importNewsDetail/${id}#comment`)
            // window.location.href = `https://mobile.aigupiao.com/express/detail/id/${ id }/jump_type/2.html`//跳转老项目
            window.location.href = `${uri}/express/detail/id/${id}`; //跳转老项目
        },
        // 平台专栏跳转详情
        handleClickAGPNewsDetail(id) {
            let uri =
                location.origin === "http://192.168.31.170:8080"
                    ? "https://mobilebeta.aigupiao.com"
                    : "";
            window.location.href = `${uri}/news/detail/id/${id}`; //跳转老项目
        },
        //点击转发的主体跳转直播详情页面
        handleClickToTranspondLiveDetail(kind, id) {
            // let {id} = this.props.msg;
            // this.props.history.push({pathname:`/liveDetail/${id}`});
            if (kind === "user_msg") {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/usermsg/id/${ id }/jump_type/1.html`
                window.location.href = `/lives/usermsg/id/${id}/jump_type/1.html`;

                //如果是老师的动态跳转到老师动态详情
            } else {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/detail/id/${ id }/jump_type/1.html`
                window.location.href = `/Lives/detail/id/${id}/jump_type/1.html`;
            }
        },
        //点击评论跳转至直播详情页
        handleClickToComment() {
            //仅粉丝可见
            if(this.is_fans_show_ok === false){
                this.$downapppop.open('查看');
                return false;
            }

            let { id, kind } = this.msg;
            if (kind === "user_msg") {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/usermsg/id/${ id }/jump_type/2.html`
                window.location.href = `/lives/usermsg/id/${id}/jump_type/2.html`;

                //如果是老师的动态跳转到老师
            } else {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/detail/id/${ id }/jump_type/2.html`
                window.location.href = `/Lives/detail/id/${id}/jump_type/2.html`;
            }
        },
        //点击文章跳转直播详情页面
        handleClickToStockGuess(id, kind) {
            if (kind === "user_msg") {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/usermsg/id/${ id }/jump_type/1.html`
                window.location.href = `/lives/usermsg/id/${id}/jump_type/1.html`;
                //如果是老师的动态跳转到老师动态详情
            } else {
                // window.location.href = `https://mobiledev.aigupiao.com/lives/detail/id/${ id }/jump_type/1.html`
                window.location.href = `/Lives/detail/id/${id}/jump_type/1.html`;
            }
        },
        handleClickToDetail(kind, id) {
            //如果已经在个人主页则不再做跳转
            //如果已经在个人主页则不再做跳转
            if (this.user_id === parseInt(id)) {
                return null;
            }
            //如果是用户发的动态，则跳到用户的个人主页
            if (kind === "user_msg") {
                // this.props.history.push({pathname:`/default/userProfiles/${id}`,state:{type:'user'}})
                // window.location.href = `https://mobiledev.aigupiao.com/ucenter/user_home/m_u_id/${ id }.html`
                window.location.href = `/ucenter/user_home/m_u_id/${id}.html`;

                //如果是老师的动态跳转到老师的个人主页
            } else {
                // this.props.history.push({pathname:`/default/userProfiles/${id}`,state:{type:'teacher'}})
                // window.location.href = `https://mobiledev.aigupiao.com/lives/center/id/${ id }.html`
                window.location.href = `/lives/center/id/${id}.html`;
            }
        },
        //点击股票区域
        handleClickToStockPage(code) {
            // let urlPath = `https://mobile.aigupiao.com/StockPage/stock/code/${ code }.html`
            let urlPath = `/StockPage/stock/code/${code}.html`;
            window.location.href = urlPath;
        },
        openDownloadAppPop() {
            //调用 src\page\appProfiles\index.vue 中的方法 openPage
            this.$parent.$parent.openPage('open_vip','查看')
        },
        async handleClickToAddOptional(stock_code, type, data) {
            if (!this.hasGetInfo) {
                this.$confirm({
                    title: "您还没有登录，是否登陆？",
                    yesBtnText: "确定",
                })
                    .then(() => {
                        window.location.href =
                            "/login/index/rd/" + new Date() * 1 + ".html";
                    })
                    .catch(() => {});
            } else {
                let addStockStatus = await HomePageApi.addStock(
                    stock_code,
                    type
                );
                if (addStockStatus.status === "success") {
                    this.$set(data, "is_follow", "yes");
                }
            }
        },
        //点击已加入
        handleClickToDelOptional(stock_code, type, data) {
            if (!this.hasGetInfo) {
                this.$confirm({
                    title: "您还没有登录，是否登陆？",
                    yesBtnText: "确定",
                })
                    .then(() => {
                        window.location.href =
                            "/login/index/rd/" + new Date() * 1 + ".html";
                    })
                    .catch(() => {});
            } else {
                this.$confirm({
                    title: "确定从自选股中移出？",
                    yesBtnText: "确定",
                })
                    .then(() => {
                        HomePageApi.delStock(stock_code, type).then((res) => {
                            if (res.status === "success") {
                                this.$set(data, "is_follow", "no");
                            }
                        });
                    })
                    .catch(() => {
                        // console.log('cancel')
                    });
            }
        },
    },
    updated() {
        if(this.msg.kind === 'vip' && !this.vip_done ){
            //老师vip消息
            console.log('updated vip .msg.kind')
            let _dom_height = $('.member_news_content_'+this.msg.id).height();
            let _dom_h2 = $('.member_news_content_25_'+this.msg.id).height();
            console.log('updated vip dom',$('.member_news_content_'+this.msg.id),$('.member_news_content_25_'+this.msg.id))
            console.log('updated vip _dom_line_hei',_dom_height,_dom_h2)
            if(_dom_height && _dom_h2){
                this.vip_done = true;
                if (_dom_height > _dom_h2) {
                    console.log('updated vip _dom_line_hei >')
                    this.showMoreFlag = true;
                } else {
                    this.showMoreFlag = false;
                }
            }
            

        }
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@mixin setBottomLine($c: #c7c7c7) {
    & {
        position: relative;
    }
    &::after {
        content: " ";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        border-bottom: 1px solid $c;
    }
    [data-dpr="1"] &:before {
        transform-origin: 0 0;
        transform: scaleY(0.5);
    }
}

@mixin setTopLine($c: #c7c7c7) {
    & {
        position: relative;
    }
    &:before {
        content: " ";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 1px;
        border-bottom: 1px solid $c;
    }
    [data-dpr="1"] &:before {
        transform-origin: 0 0;
        transform: scaleY(0.5);
    }
}

.dl_check_box {
    background: #ffffff;
    height: 44px;
    line-height: 44px;
    width: 100%;
    text-align: center;
}
.dl_check_box a {
    color: #507daf;
    font-size: 16px;
}

.live_item:last-child {
    margin-bottom: 0;
}

.live_item {
    background: #fff;
    margin-bottom: 10px;
    //强制英文长单词换行
    word-break: break-all;
    word-wrap: break-word;
    border-radius: 7px;
    .is_only_self_show {
        height: 34px;
        background-image: url("../../assets/images/icon_only_self_show@2x.png");
        background-repeat: no-repeat;
        background-size: 12px 14px;
        background-position: 12px 10px;
        text-indent: 30px;
        color: #919191;
        line-height: 34px;
        font-size: 14px;
        width: 100%;
        @include setBottomLine(#ebebeb);

        &.is_fans_show, &.is_vip_show{
            background: none;
            display: flex;
            align-items: center;
            text-indent: 0;
            svg{
                width: 14px;
                height: 14px;
                flex-shrink: 0;
                margin-left: 12px;
                margin-right: 4px;
            }
        }
    }
    //头部样式
    .live_header {
        position: relative;
        padding: 14px 14px 10px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .user_detail {
            display: flex;

            dt {
                width: 45px;
                height: 45px;
                border: 1px solid #e6e6e6;
                border-radius: 50%;
                margin-right: 10px;
                overflow: hidden;

                > img {
                    width: 100%;
                    height: 100%;
                }
            }

            dd {
                flex: 1;

                h4 {
                    display: flex;
                    align-items: center;
                    margin: 3px 0 6px 0;

                    .user_name {
                        font-size: 16px;
                        color: #333333;
                        font-weight: 500;
                        height: 18px;
                        line-height: 18px;
                    }

                    .user_symbol {
                        width: 14px;
                        height: 14px;
                        margin-left: 6px;
                        line-height: 0;

                        > img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                p {
                    font-size: 12px;
                    line-height: 18px;
                    color: #a0a0a0;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }

        .user_operation {
            width: 14px;
            height: 2px;
            margin-right: 3px;

            img {
                width: 100%;
                height: 100%;
            }
        }
        .is_top_msg {
            position: absolute;
            top: 0;
            right: 14px;
            width: 51px;
            height: 44px;
            background: url(../../assets/images/icon_top_msg@2x.png);
            background-size: 100%;
        }
    }
    .live_content_box {
        background: #ffffff;
    }
    //纯文字样子
    .live_content {
        color: #333333;
        font-size: 15px;
        line-height: 21px;
        //padding: 0px 14px 0;

        margin: 0px 14px 0;
        position: relative;

        .live_content_fans_noshow{
            display: flex;
            align-items: center;
            height: 42px;
            color: #636363;
            border-top: .5px solid #ebebeb;
            border-bottom: .5px solid #ebebeb;
            svg{
                margin-left: 6px;
                margin-right: 12px;
                width: 22px;
                height: 22px;
                flex-shrink: 0;
            }
        }

        > div {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
        }

        &.live_content082901 > div{
            display: block;
            // max-height: 84px;
            line-height: 21px;
            text-align: justify;

            &.bindShow {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                overflow: hidden;
            }

            &.normalShow {
                -webkit-line-clamp: 9999;
                max-height: unset;
                overflow: unset;
                >span{
                    display: inline;
                }
            }
        }

        .contentCloseBtn{
            font-size: 15px;
            line-height: 21px;
            color: #1D88D0;
            padding-right: 14.5px;
            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/text_arrow.svg");
            background-size: 10.5px 6px;
            background-repeat: no-repeat;
            background-position: right center;
        }

        button.show_more_wrap {
            width: 100%;
            height: 21px;
            width: 55px;
            white-space: nowrap;
            position: absolute;
            right: 0;
            bottom: 0;
            background-color: transparent;
            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/text_lineG.svg");
            background-repeat: no-repeat;
            background-size: 100%;
            text-align: right;
            font-size: 15px;
            line-height: 1;
            color: #1D88D0;
            font-weight: normal;
            cursor: pointer;
            user-select: none;
            border: none;
            outline: none;
            padding: 0;
            padding-bottom:1px;

            &.isAd {
                padding: 0;
            }
            }
        a font{
            font-size: 15px!important;
        }

       
    }

    //图片样式
    .thumbnail {
        display: flex;
        padding: 0 11px 0;

        .img-item {
            width: 33.33%;
            padding: 3px;
            box-sizing: border-box;
            margin: 0;
        }

        > div {
            height: 111px;
            width: 111px;

            > img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .transmit_image {
        padding: 6px 6px 0;
        // height: 136px;
    }

    //视频专辑样式
    .video_special {
        padding: 6px 14px 0;

        .video_cover {
            height: 198px;
            position: relative;

            > img {
                width: 100%;
                height: 100%;
            }

            .play_btn {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -23px;
                margin-left: -23px;
                width: 47px;
                height: 47px;

                > img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .video_special_detail {
            display: flex;
            box-sizing: content-box;
            height: 60px;
            justify-content: space-between;
            padding: 0 10px;
            background: #f5f6f7;

            > div {
                height: 100%;
                display: flex;
                flex-direction: column;

                > h4 {
                    height: 17px;
                    font-size: 15px;
                    color: #222222;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-weight: 400;
                    margin: 10px 0 8px 0;
                    line-height: 17px;
                }

                > p {
                    font-size: 14px;
                    // color:@color-gray-middle;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #636363;
                    font-size: 13px;
                }
            }

            > dl {
                flex-shrink: 0;
                height: 100%;
                display: flex;
                flex-direction: column;
                // justify-content: space-around;
                align-items: center;

                > dt {
                    width: 27px;
                    height: 22px;
                    margin: 9px 0 6px 0;

                    > img {
                        width: 100%;
                        height: 100%;
                    }
                }

                > dd {
                    font-size: 14px;
                    color: #fe696b;
                }
            }
        }
    }

    //会员消息不能看全部的样式
    .members_only {
        .members_only_free {
            padding: 6px 14px 0;
            color: #222222;
            font-size: 16px;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;

            .user_name {
                color: #507daf;
                margin-right: 5px;
            }
        }

        .transpond {
            background: #ffffff;
        }

        .members_only_box {
            // margin: 10px 12px 0;
            // padding-left: 0 18px;
            padding: 12px 18px 0;

            &.zf {
                background: #ffffff;
            }

            .vip_nosee_company {
                height: 56px;
                display: flex;
                align-items: center;
                border-top: 1px solid #f7f7f7;
                border-bottom: 1px solid #f7f7f7;

                // @include setTopLine(#ebebeb);
                // @include setBottomLine(#ebebeb);
                span {
                    width: 23px;
                    height: 23px;
                    background: url(https://cdncos.aigupiao.com/assets/wap/img/lock_content.png);
                    margin-right: 15px;
                    margin-left: 21px;

                    background-size: 99% 99%;
                    background-repeat: no-repeat;
                }

                .vip_company_info {
                    b {
                        font: 15px/21px "微软雅黑";
                        color: #939393;
                        display: block;
                        font-weight: 500;
                    }
                }
            }
        }
    }

    //会员消息可看全部的样式
    .member_brief {
        font-size: 16px;
        line-height: 22px;
        padding: 6px 12px 0;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;

        .user_name {
            color: #507daf;
            margin-right: 5px;
        }
    }
    .member_pad {
        height: 6px;
        width: 100%;
    }

    .transpond {
        background: #ffffff;
    }
    .member_news_box {
        padding: 0 14px;
        .member_news {
            background: #fffbef;

            .member_news_header {
                height: 37px;
                box-sizing: border-box;
                border-bottom: 1px solid #ffe7d3;

                display: flex;
                align-items: center;
                margin: 0 10px;

                > dl {
                    height: 100%;
                    display: flex;
                    align-items: center;

                    > dt {
                        width: 17px;
                        height: 17px;
                        flex-shrink: 0;

                        > img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    > dd {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        margin-left: 9px;

                        > h4 {
                            color: #ff8f17;
                            font-size: 14px;
                            line-height: 22px;
                        }

                        // > p {
                        //   color: #ff8f17;
                        //   font-size: 12px;
                        //   line-height: 17px;
                        //   display: -webkit-box;
                        //   -webkit-box-orient: vertical;
                        //   -webkit-line-clamp: 4;
                        //   overflow: hidden;
                        // }
                    }
                }
            }

            .member_news_content {
                color: #333333;
                font-size: 14px;
                line-height: 21px;
                margin: 7px 10px 0;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                overflow: hidden;




                &.member_news_content_25{
                    display: block;
                    -webkit-box-orient: unset;
                    -webkit-line-clamp: unset;
                    // max-height: 84px;
                    position: relative;
                    text-align: justify;
                    button.show_more_wrap {
                        width: 100%;
                        height: 21px;
                        width: 55px;
                        white-space: nowrap;
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        background-color: transparent;
                        background-image: url("https://cdncos.aigupiao.com/assets/pc/img/2023/zksq_wap.svg");
                        background-repeat: no-repeat;
                        background-size: 100%;
                        text-align: right;
                        font-size: 14px;
                        line-height: 1;
                        color: #1D88D0;
                        font-weight: normal;
                        cursor: pointer;
                        user-select: none;
                        border: none;
                        outline: none;
                        padding: 0;
                        padding-bottom:1px;

                        &.isAd {
                            padding: 0;
                        }
                    }
                    .contentCloseBtn{
                        font-size: 14px;
                        line-height: 21px;
                        color: #1D88D0;
                        padding-right: 14.5px;
                        background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/text_arrow.svg");
                        background-size: 10.5px 6px;
                        background-repeat: no-repeat;
                        background-position: right center;
                    }

                    &.bindShow {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 4;
                        overflow: hidden;
                    }
                }

                &.normalShow {
                    -webkit-line-clamp: 9999;
                    max-height: unset;
                    overflow: unset;
                    >span{
                        display: inline;
                    }
                }
            }
            .member_content_pad {
                width: 100%;
                height: 9px;
                background: #fffbef;
            }
        }
        .img_box {
            // padding-top: 0;
            // padding-bottom: 7px;
            .thumbnail {
                padding: 0 7px 0;
            }
        }
    }

    //尾部评论点赞样式
    .live_footer {
        width: 100%;
        height: 44px;
        box-sizing: border-box;

        .footer_top_border {
            // border-top: 1px solid #e6e6e6;
            display: flex;
            width: 100%;
            height: 44px;
            align-items: center;
            color: #8b8b8b;

            .give_like {
                margin: 9px 0;
                flex: 1;
                text-align: center;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                span img {
                    width: 20px;
                    height: 20px;
                    margin-right: 6px;
                }
            }

            .give_comment {
                margin: 9px 0;
                flex: 1;
                text-align: center;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                span img {
                    width: 20px;
                    height: 20px;
                    margin-right: 6px;
                }
            }
        }
    }

    //专栏样式
    .special_column {
        padding: 0 14px 0;

        .special_column_title {
            font-size: 15px;
            font-weight: bold;
            color: #222222;
            font-family: PingFangSC-Medium;
            line-height: 24px;
            margin-bottom: 6px;
            //最多两行显示
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }

        .special_column_content {
            color: #636363;
            font-size: 15px;
            line-height: 22px;
            //专栏最多3行显示
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
        }
    }
    .charge_kaitong_box {
        padding: 0 14px;
        margin-top: 12px;
        .charge_kaitong {
            height: 49px;
            border-top: 1px solid #f7f7f7;
            border-bottom: 1px solid #f7f7f7;
            display: flex;
            align-items: center;
            text-indent: 59px;
            font-size: 15px;
            color: #636363;
            background: url(https://cdncos.aigupiao.com/assets/pc/img/icon-zl-vip.png)
                no-repeat 23px center;
            background-size: 23px 23px;
            .price_text {
                font-style: normal;
                color: #fe484a;
            }
        }
    }

    //分享股票
    .transpond_stock_wrap {
        padding: 10px 14px 0;
        .transpond_stock_content {
            height: 60px;
            padding: 6px;
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            border: 1px solid rgba(245, 245, 245, 1);
            display: flex;
            box-sizing: border-box;
            box-shadow: 0px 0px 14px 0px rgba(67, 67, 67, 0.07);

            .transpond_title {
                width: 85px;
                height: 48px;
                margin-right: 10px;
                .stock_stock_info {
                    height: 48px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    padding-left: 10px;
                    box-sizing: border-box;
					font-size: 13px;
					
                    &.to_green {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_stock_down.png);
                        background-size: 100%;
                    }
                    &.to_red {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_stock_up.png);
                        background-size: 100%;
                    }
                    > span {
                        display: block;
                        color: #ffffff;
                        font-size: 15px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 18px; /* 120% */

                        &:last-of-type {
                            font-weight: 500;
                            line-height: 16px;
                            font-size: 13px;
                            color: #fff;
                            margin-top: 2px;
                        }
                    }
                }
            }
            .transpond_detail {
                height: 100%;
                .transpond_list {
                    height: 100%;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
					
					p {
						font-size: 15px;
					}
                    .stock-code {
                        color: #939393;
                        font-size: 15px;
                    }
                }
                .stock_info_right {
                    font-size: 12px;
                    color: #9f9f9f;
                    > p {
                        display: flex;
                        align-items: center;
                        > img {
                            margin-left: 5px;
                            transform: rotate(-90deg);
                            width: 8px;
                            height: 8px;
                        }
                    }
                }
            }
        }
    }

    // 分享板块
    .transpond_plate_wrap {
        padding: 10px 14px 0;
        .transpond_plate_content {
            height: 60px;
            padding: 6px;
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            border: 1px solid rgba(245, 245, 245, 1);
            display: flex;
            box-sizing: border-box;
            box-shadow: 0px 0px 14px 0px rgba(67, 67, 67, 0.07);

            .transpond_title {
                width: 85px;
                height: 48px;
                margin-right: 10px;
                .plate_stock_info {
                    height: 48px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    // padding-left: 10px;
                    box-sizing: border-box;
                    text-align: center;
					font-size:15px;
                    &.to_green {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_plate_down.png);
                        background-size: 100%;
                    }
                    &.to_red {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_plate_up.png);
                        background-size: 100%;
                    }
                    > span {
                        display: block;
                        color: #ffffff;
                        &:first-child {
                            // font-size: 16px;
                            font-weight: bold;
                        }
                    }
                }
            }
            .transpond_detail {
                height: 100%;
                .transpond_list {
                    height: 100%;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
					
					p {
						font-size: 15px;
					}
					
                    .plate-code {
                        color: #939393;
                        font-size: 15px;
                    }
                }
                .plate_info_right {
                    font-size: 12px;
                    color: #9f9f9f;
                    > p {
                        display: flex;
                        align-items: center;
                        > img {
                            margin-left: 5px;
                            transform: rotate(-90deg);
                            width: 8px;
                            height: 8px;
                        }
                    }
                }
            }
        }
    }

    //分享组合
    .transpond_simulation_wrap {
        padding: 10px 14px 0;
        .transpond_simulation_content {
            height: 60px;
            padding: 6px 10px 6px 6px;
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            border: 1px solid rgba(245, 245, 245, 1);
            display: flex;
            box-sizing: border-box;
            box-shadow: 0px 0px 14px 0px rgba(67, 67, 67, 0.07);

            .transpond_title {
                width: 85px;
                height: 48px;
                margin-right: 10px;
                .simulation_stock_info {
                    height: 48px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    // padding-left: 10px;
                    box-sizing: border-box;

                    &.to_green {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_down.png);
                        background-size: 100%;
                    }
                    &.to_red {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_up.png);
                        background-size: 100%;
                    }
                    > span {
                        display: block;
                        color: #ffffff;
                        font-size: 11px;
                        width: 100%;
                        text-align: center;
                        &:first-child {
                            font-size: 15px;
                            // font-weight: bold;
                        }
                    }
                }
            }
            .transpond_detail {
                height: 100%;
                flex: 1;
                .transpond_list {
                    height: 100%;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                }
                .simulation_info_right {
                    font-size: 12px;
                    color: #9f9f9f;
                    > p {
                        display: flex;
                        align-items: center;
                    }
                }
            }
            .attention_box {
                height: 100%;
                flex-direction: column;
                display: flex;
                justify-content: center;
                align-items: flex-end;
                padding: 2px 0;
                box-sizing: border-box;

                .attention_btn {
                    width: 44px;
                    height: 20px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 3px;
                    border: 1px solid rgba(254, 72, 74, 1);
                    color: #fe484a;
                    font-size: 12px;
                    text-align: center;
                    line-height: 20px;
                    &.is_follow {
                        color: #9f9f9f;
                        border-color: #cfcfcf;
                    }
                }
                > p {
                    color: #9f9f9f;
                    font-size: 12px;
                }
            }
        }
    }
    // 分享趣味竞猜
    .transpond_guess {
        padding: 10px 14px 0;

        .transpond_guess_content {
            height: 78px;
            padding: 6px 10px 6px 6px;
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            border: 1px solid rgba(245, 245, 245, 1);
            display: flex;
            box-sizing: border-box;
            box-shadow: 0px 0px 14px 0px rgba(67, 67, 67, 0.07);

            .transpond_title {
                width: 66px;
                height: 66px;
                margin-right: 10px;
                position: relative;
                > img {
                    width: 100%;
                    height: 100%;
                }
                .plate_img_text {
                    position: absolute;
                    width: 100%;
                    bottom: 0;
                    left: 0;
                    color: #ffffff;
                    font-size: 12px;
                    line-height: 22px;
                    text-align: center;
                }
            }
            .transpond_detail {
                height: 100%;
                display: flex;
                justify-content: space-between;
                flex: 1;

                .guess_list {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .guess_title {
                        color: #222222;
                        font-size: 15px;
                        line-height: 18px;
                        margin-top: 6px;
                        padding-right: 10px;
                    }

                    .guess_num {
                        font-size: 12px;
                        line-height: 16px;
                        color: #9f9f9f;
                        margin-bottom: 4px;
                    }
                }

                .guess_btns {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: space-around;

                    > div.guess_btn {
                        width: 42px;
                        height: 26px;
                        background: #fe484a;
                        border-radius: 4px;
                        color: #ffffff;
                        text-align: center;
                        font-size: 12px;
                        line-height: 26px;
                    }
                }
            }
        }
    }
    // 分享投票
    .transpond_vote_wrap {
        padding: 11px 14px 0;
        .transpond_vote_content {
            background: #f5f6f7;
            padding: 0 10px 3px;
            .transpond_vote_title {
                font-size: 15px;
                color: #333333;
                height: 42px;
                line-height: 42px;
            }
            .transpond_vote_desc {
                font-size: 12px;
                color: #939393;
                height: 20px;
                line-height: 20px;
                margin-bottom: 10px;
            }
            .transpond_vote_items {
                > li {
                    height: 36px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 2px;
                    border: 1px solid rgba(234, 234, 234, 1);
                    line-height: 36px;
                    text-align: center;
                    font-size: 15px;
                    color: #333333;
                    margin-bottom: 9px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            .transpond_vote_footer {
                display: flex;
                justify-content: space-between;
                height: 34px;
                line-height: 34px;
                .close_time {
                    font-size: 12px;
                    color: #939393;
                }
                .create_user {
                    color: #939393;
                    font-size: 12px;
                    > .create_user_name {
                        color: #1d88d0;
                    }
                }
            }
        }
    }

    .transpond_kline_wrap {
        padding: 10px 14px 0;
        .transpond_kline_content {
            height: 70px;
            padding: 0 12px 0 5px;
            background: #f7f7f7;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .kline_img {
                width: 62px;
                height: 62px;
                flex-shrink: 0;
                > img {
                    width: 100%;
                    height: 100%;
                }
            }
            .kline_detail {
                flex: 1;
                padding-left: 8px;
                width: 170px;
                > h3 {
                    font-size: 15px;
                    color: #393939;
                    margin-bottom: 7px;
                    font-weight: bold;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .user_box {
                    height: 24px;
                    display: flex;
                    align-items: center;
                    .user_list {
                        height: 24px;
                        // position: relative;
                        display: flex;
                        > li {
                            width: 20px;
                            height: 20px;
                            border: 2px solid rgba(247, 247, 247, 1);
                            position: relative;
                            top: 0;
                            border-radius: 50%;
                            overflow: hidden;
                            > img {
                                width: 100%;
                                height: 100%;
                            }
                            &:nth-child(1) {
                                left: 0;
                                z-index: 3;
                            }
                            &:nth-child(2) {
                                left: -4px;
                                z-index: 2;
                            }
                            &:nth-child(3) {
                                left: -8px;
                                z-index: 1;
                            }
                        }
                    }
                    .user_num {
                        color: #939393;
                        font-size: 12px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
            .kline_challenge {
                width: 70px;
                height: 28px;
                flex-shrink: 0;

                background: linear-gradient(
                    115deg,
                    rgba(255, 172, 117, 1) 0%,
                    rgba(255, 173, 29, 1) 100%
                );
                border-radius: 14px;
                font-size: 13px;
                color: #ffffff;
                text-align: center;
                line-height: 28px;
            }
        }
    }
    //分享语音直播间
    .transpond_audio_live_wrap {
        padding: 10px 14px 0;
        .transpond_audio_live_content {
            height: 60px;
            padding: 6px 12px 6px 7px;
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            border: 1px solid rgba(245, 245, 245, 1);
            display: flex;
            box-sizing: border-box;
            box-shadow: 0px 0px 14px 0px rgba(67, 67, 67, 0.07);
            .transpond_audio_live_info {
                width: 75px;
                height: 48px;
                border-radius: 3px;
                overflow: hidden;
                flex-shrink: 0;
                position: relative;
                > .bg {
                    width: 100%;
                    height: 100%;
                    position: relative;
                    > img {
                        width: 100%;
                        height: 100%;
                    }
                    .shade_wrap {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(54, 54, 54, 0.5);
                    }
                }
                .live_attendance {
                    position: absolute;
                    top: 15px;
                    left: 10px;
                    width: 57px;
                    height: 19px;
                    background-size: 100%;
                    > p {
                        text-indent: 22px;
                        line-height: 19px;
                        font-size: 10px;
                        color: #ffffff;
                        width: 57px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .icon_audio_started {
                        position: absolute;
                        top: 3px;
                        left: 3px;
                        width: 13px;
                        height: 10px;
                        background-image: url("../../assets/images/icon_audio_started.gif");
                        background-size: 100%;
                        background-position: 0 center;
                        background-repeat: no-repeat;
                    }
                }
                .over_attendance {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    padding: 5px;
                    box-sizing: border-box;
                    left: 0;
                    top: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;
                    > .play_icon {
                        width: 20px;
                        height: 20px;
                        background-size: 100%;
                    }
                    > .over_attendance_num {
                        font-size: 10px;
                        color: #ffffff;
                        text-align: center;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
                .about_of_live_attendance {
                    position: absolute;
                    width: 100%;
                    bottom: 4px;
                    left: 0;
                    text-align: center;
                    color: #ffffff;
                    font-size: 10px;
                }
            }
            .transpond_detail {
                height: 100%;
                width: 140px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                flex: 1;
                padding-left: 7px;

                > h3 {
                    color: #282828;
                    font-size: 15px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                > p {
                    color: #9f9f9f;
                    font-size: 12px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .join_wrap {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: flex-end;
                flex-shrink: 0;

                > .live_streaming {
                    // width: 39px;
                    height: 16px;
                    font-size: 10px;
                    line-height: 16px;
                    text-align: center;
                    padding: 0 4px;
                    border-radius: 2px;
                    &.about_of {
                        color: #ffffff;
                        background: #fe484a;
                    }
                    &.live {
                        color: #ffffff;
                        background: #fe484a;
                    }
                    &.over {
                        color: #ffffff;
                        background: #cccccc;
                    }
                }
                .audio_live_price {
                    font-size: 12px;
                    color: #9f9f9f;
                    display: flex;
                    align-items: center;
                    > .join_icon {
                        width: 11px;
                        height: 9px;
                        background-size: 100%;
                    }
                }
            }
        }
    }

    .to_green {
        color: #0ac890;
    }

    .to_red {
        color: #fe484a;
    }
    .AGP_face {
        width: 18px;
        height: 18px;
        vertical-align: sub;
    }
}

.vedio_img {
    // width: 100px !important;
    // background-color: red;
    height: 100%;

    .vedio_image {
        display: block;
        height: 100%;
        position: relative;

        > img {
            height: 100%;
            width: 100%;
        }

        p {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;

            .vedio_time {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 70px !important;
                height: 23px !important;
                background: rgba(0, 0, 0, 0.5);
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .vedio_time_icon {
                    line-height: 23px;
                    width: 14px !important;
                    height: 14px !important;
                    margin-left: 7px;
                }

                > i {
                    color: #fff;
                    font-size: 14px !important;
                    line-height: 23px !important;
                    padding-left: 10px;
                    font-style: normal;
                }
            }
        }
    }
}

.vedio_play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px !important;
    height: 30px !important;
}

//转发要闻样式
.transpond_important_news {
    background: #ffffff;
    padding: 0 14px;
    margin-top: 10px;
    .news_bg {
        background: #f5f6f7;
        padding: 7px 10px;
        > p {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            font-size: 14px;
            line-height: 20px;
            color: #636363;
        }

        .important_news_mark {
            color: #1d88d0;
        }
    }
    .transpond_ordinary_image {
        background: #f5f6f7;
        > .img_box {
            padding-top: 0;
            padding-bottom: 7px;
            .thumbnail {
                padding: 0 10px 0;
            }
        }
    }
}

//转发专栏样式
.transpond_special_column {
    padding: 0px 14px 0px 12px;
    background: #ffffff;
    margin-top: 10px;
    .user_msg {
        display: flex;
        // height: 39px;
        align-items: center;

        .user_name {
            font-size: 14px;
            color: #1d88d0;
            line-height: 21px;
            margin-bottom: 2px;
        }

        .content_type {
            width: 48px;
            height: 15px;
            margin-left: 9px;

            > img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .transpond_box {
        // width: 100%;
        // display: flex;
        background: #f5f6f7;

        .user_img {
            width: 60px;
            height: 60px;
            flex-shrink: 0;

            > img {
                width: 100%;
                height: 100%;
            }
        }

        .transpond_content {
            display: flex;
            flex-direction: column;
            // padding: 0 15px 0 11px;
            justify-content: space-between;
            padding: 8px 11px;

            .transpond_title {
                font-size: 14px;
                line-height: 22px;
                color: #636363;
                display: -webkit-box;
                display: -moz-box;

                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;

                -webkit-line-clamp: 1;
                -moz-line-clamp: 1;

                overflow: hidden;
                margin-bottom: 2px;
                font-weight: bold;
            }

            .transpond_brief {
                font-size: 14px;
                color: #636363;
                line-height: 21px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
            }
        }
        .transpond_ordinary_image {
            > .img_box {
                padding-top: 0;
                padding-bottom: 7px;
                .thumbnail {
                    padding: 0 8px 0;
                }
            }
        }
    }
}

.transpond_vip_box {
    //转发会员消息
    .transpond_vip {
        padding: 12px 14px;
        background: #ffffff;
        .members_only {
            background: #f5f6f7;
            padding: 0 5px 12px;
            .members_only_free {
                background: #f5f6f7;
                padding: 6px 0 0;
                margin-bottom: 5px;
                color: #636363;
            }
            .members_only_box.zf {
                background: #f5f6f7;
                padding: 0;
            }
        }

        .member_brief {
            background: #f5f6f7;
        }
        .member_pad {
            background: #f5f6f7;
        }
        .member_news_box {
            background: #f5f6f7;
            padding: 0;
        }
        .member_content_pad {
            width: 100%;
            height: 9px;
            background: #fffbef;
        }
    }
}
//转发普通消息
.transpond_ordinary {
    padding: 12px 14px;
    background: #ffffff;
    .forward-main {
        background: #f5f6f7;
        .transpond_detail {
            background: #fff !important;
        }
        // 转发股票
        .transpond_stock_wrap {
            padding: 0 5px 5px;
        }
        .transpond_plate_wrap {
            padding: 0 5px 5px;
        }
        .transpond_simulation_wrap {
            padding: 0 5px 5px;
        }
        .transpond_guess {
            padding: 0 5px 5px;
        }
        .transpond_vote_wrap {
            padding: 0 5px 5px;
        }
        .transpond_kline_wrap {
            padding: 0 5px 5px;
            .transpond_kline_content {
                background: #ffffff;
            }
        }
        .transpond_audio_live_wrap {
            padding: 0 5px 5px;
        }
        .transpond_vote_wrap {
            padding: 0 5px 5px;
        }
        // .transpond_vip_wrap {
        // }
    }

    .transpond_ordinary_content {
        font-size: 15px;
        line-height: 21px;
        color: #636363;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        background: #f5f6f7;
        padding-bottom: 8px;
        padding-top: 8px;

        .user_name {
            color: #1d88d0;
            // margin-right: 5px;
            font-size: 15px;
            // line-height: 32px;
            text-indent: 10px;
        }
        .transpond_ordinary_content_text {
            font-size: 14px;
            line-height: 20px;
            color: #636363;
            padding: 0px 10px 0;
            overflow: hidden;
            -webkit-line-clamp: 4;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            a font{
                font-size: 14px!important;
            }

            span {

            }
        }
    }
    .transpond_ordinary_image {
        background: #f5f6f7;
        > .img_box {
            padding-top: 0;
            padding-bottom: 7px;
            .thumbnail {
                padding: 0 10px 0;
            }
        }
    }
    .transpond_audio_wrap {
        padding: 5px;
        background: #f5f6f7;

        > .audio_msg_box {
            padding: 0;
            > .audio_msg_content {
                background: #ffffff;
            }
        }
    }
    .video_special {
        background: #f5f6f7;
    }
}

//转发和分享不支持内容
.nonsupport_box {
    // font-size: 12px;
    // padding-right:25px;
    padding: 12px 0;
    text-align: center;
    line-height: 22px;
    background: #ffffff;

    > a {
        color: #4e7aa2;
    }
}

> .icon_vote {
    display: inline-flex;
    width: 19px;
    height: 15px;
    align-items: center;
    margin-left: 3px;
    padding-top: 3px;
    vertical-align: top;
    > img {
        width: 100%;
        height: 100%;
    }
}
.icon_img {
    display: inline-flex;
    width: 19px;
    height: 15px;
    align-items: center;
    margin-left: 3px;
    padding-top: 3px;
    vertical-align: top;
    > img {
        width: 100%;
        height: 100%;
    }
}
.icon_video {
    display: inline-flex;
    width: 19px;
    height: 15px;
    align-items: center;
    margin-left: 3px;
    padding-top: 3px;
    vertical-align: top;
    > img {
        width: 100%;
        height: 100%;
    }
}
// // @机器人诊股
// .robot_box {
//   padding: 14px;
//   .robot_title {
//     font-size: 15px;
//     color: #333333;
//     line-height: 21px;
//     margin-bottom: 10px;
//     > .user_name {
//       color: #fe9017;
//     }
//   }
//   .robot_content_box {
//     height: 40px;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     > .robot_avatar {
//       width: 40px;
//       height: 40px;
//       border-radius: 50%;
//       overflow: hidden;
//       > img {
//         width: 100%;
//         height: 100%;
//       }
//     }
//     .robot_read_num {
//       font-size: 12px;
//       color: #a0a0a0;
//     }
//   }
// }
</style>
<style lang="scss">
.transpond_ordinary_content_text span span{
    font-size: 15px !important;
}
</style>